module.exports = __webpack_public_path__ + "static/media/error.c29f954c.svg";